"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickupEligibilityStatus = exports.PickupStatus = exports.PickupConfirmationAction = void 0;
var PickupConfirmationAction;
(function (PickupConfirmationAction) {
    PickupConfirmationAction["Approve"] = "Approve ";
    PickupConfirmationAction["Rejected"] = "Rejected";
    PickupConfirmationAction["ClientOffLine"] = "ClientOffLine";
    PickupConfirmationAction["Pending"] = "Pending";
})(PickupConfirmationAction || (exports.PickupConfirmationAction = PickupConfirmationAction = {}));
var PickupStatus;
(function (PickupStatus) {
    PickupStatus["Pending"] = "Pending";
    PickupStatus["InProgress"] = "InProgress";
    PickupStatus["Completed"] = "Completed";
    PickupStatus["Cancelled"] = "Cancelled";
    PickupStatus["ClientReject"] = "ClientReject";
    PickupStatus["Approved"] = "Approved";
})(PickupStatus || (exports.PickupStatus = PickupStatus = {}));
var PickupEligibilityStatus;
(function (PickupEligibilityStatus) {
    PickupEligibilityStatus["Eligible"] = "Eligible";
    PickupEligibilityStatus["AlreadyPickedUp"] = "AlreadyPickedUp";
    PickupEligibilityStatus["NotPaid"] = "NotPaid";
    PickupEligibilityStatus["DisputeExists"] = "DisputeExists";
    PickupEligibilityStatus["Error"] = "Error";
    PickupEligibilityStatus["Delivered"] = "Delivered";
    PickupEligibilityStatus["Cancelled"] = "Cancelled";
})(PickupEligibilityStatus || (exports.PickupEligibilityStatus = PickupEligibilityStatus = {}));
//# sourceMappingURL=pickup.js.map